import { render, staticRenderFns } from "./WaybillSidebarBatchReview.vue?vue&type=template&id=701513ce&"
import script from "./WaybillSidebarBatchReview.vue?vue&type=script&lang=js&"
export * from "./WaybillSidebarBatchReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports